document.addEventListener('DOMContentLoaded', () => {
    const viewers = document.querySelectorAll(".adam__content-slider");
    viewers.forEach((element) => {
        new ImageCompare(element).mount();
    });
});